module.exports = __webpack_public_path__ + "static/media/Aneri.ba87910c.jpeg";